import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import Modal from '@/components/modalBase/modalBase'
import { State, Action, Getter } from 'vuex-class'

@Component({
  components: {
    Modal
  },
  computed: {
    challengeStatus () {
      let data
      if (this.getInsChallenge.is_accomplished !== null) {
        switch (this.getInsChallenge.is_accomplished) {
          case true:
            data = {
              class: 'gano',
              message: 'Haz ganado,  tienes madera para los retos sigue acomulando victorias para el premio final!'
            }
            break
          case false:
            data = {
              class: 'perdio',
              message: 'Has perdido este reto, no te preocupes sigue intentando para llegar al premio final'
            }
            break
        }
      } else {
        switch (this.getInsChallenge.is_accepted) {
          case true:
            data = {
              class: 'aceptado',
              message: 'Este reto ha sido aceptado, el runner validará que fue relalizado con exito para que recibas tu premio'
            }
            break
          case false:
            data = {
              class: 'rechazado',
              message: 'Este reto ha sido rechazado, para volver a recibir un reto vuelve a pedir.'
            }
            break
        }
      }

      return data
    }
  }
})
export default class ChallengeModal extends Vue {
  @Prop({ default: false }) show!: Boolean
  @Prop({ default: () => {} }) data!: Object
  @Prop({ default: () => {} }) order!: Object

  @Action action_getChallengue: any
  @Action action_putChallengueIns: any

  @Getter getInsChallenge: any
  @Getter getChallengeData: any

  mounted () {
    this.action_getChallengue(this.getInsChallenge)
  }

  info: any = null

  @Emit()
  closeModal () {
    // @ts-ignore
    this.$ga.event('Reto', 'Salir', 'Salir')
  }

  async _updateChallenge (action: any) {
    // evento analitica
    try {
      if (action) {
        // @ts-ignore
        this.$ga.event('Reto', 'Aceptar', 'Aceptar')
      } else {
        // @ts-ignore
        this.$ga.event('Reto', 'Rechazar', 'Rechazar')
      }
      let data = {
        order: {
          id: (this.order as any).id
        },
        challenge: {
          is_accepted: action
        }
      }
      await this.action_putChallengueIns(data)
      this.$emit('close-modal')
    } catch (error) {
      const status = error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Oops...',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Oops...',
          text: error.response.data.message
        })
      }
    }
  }
}
